module.exports = __webpack_public_path__ + "static/media/logo-menu-brand@2x.68def9c0.png";